import { PromotedServiceAssignment, useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { MewsTeam } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

export const useDeleteServicePromotion = () =>
    useRepositoryMutation('promotedServiceAssignments', 'delete', {
        transformParams: ({ promotedService }: { promotedService: PromotedServiceAssignment }) => ({
            promotedServiceAssignmentIds: [promotedService.id],
            serviceId: promotedService.serviceId,
        }),
        invalidateQueries: { promotedServiceAssignments: ['getAll'] },
        onSuccess: () => {
            showSuccessAlert({
                description: lt(TextKey.PromotedServiceAssignmentDeletedSuccessMessage),
            });
        },
        meta: {
            logError: {
                team: MewsTeam.Spacetime,
            },
        },
    });
